/** FGTS × BMS. */

import { httpV1 as http } from '@/services/api';

const CONTEXT = '/bms/fgts';

// Supplier kill-switch — true suspends consult/simulation/approve/tryAgain.
const DISABLED = false;
const DISABLED_MESSAGE = 'Consultas ao fornecedor BMS estão temporariamente suspensas.';

function rejectDisabled() {
  return Promise.reject(new Error(DISABLED_MESSAGE));
}

export async function consult(params) {
  if (DISABLED) return rejectDisabled();
  return http.get(`${CONTEXT}/balance`, { params });
}

export async function simulation(data) {
  if (DISABLED) return rejectDisabled();
  return http.post(`${CONTEXT}/simulation`, data);
}

export async function approve(data) {
  if (DISABLED) return rejectDisabled();
  return http.post(`${CONTEXT}/credit-operation`, data);
}

export async function verify(params) {
  return http.get(`${CONTEXT}/proposal`, { params });
}

export async function cancel(data) {
  return http.post(`${CONTEXT}/cancel`, data);
}

export async function receipt(id, params) {
  return http.get(`/bms/fgts/reserve_balance/${id}/generate_receipt`, { params });
}

export async function tryAgain(data) {
  if (DISABLED) return rejectDisabled();
  return http.put(`${CONTEXT}/credit-operation`, data);
}

/* Settlement (PayoffCharges) */
export async function listOpenInstallments(params) {
  return http.get(`${CONTEXT}/payoff/installments`, { params });
}

export async function generateBankSlip(data) {
  return http.post(`${CONTEXT}/payoff/generate-bank-slip`, data);
}
